import { API } from "@/lib/api";

export const fileUrl = (p) => (!p ? "" : p.startsWith("http") ? p : `${API}/files/${p}`);
